import { InventoryCountItemTemplateListPage } from "@/features/inventory-count-template-item/pages/InventoryCountItemTemplateListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/inventory-count-template-item/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["inventory_count_item_template.view"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: InventoryCountItemTemplateListPage,
});
